import { z } from 'zod';
import { HttpUrl } from './common/url.js';
/** Support tickets (FR-HELP-02, AC-HELP-01). */
export const TicketCategory = z.enum(['account', 'payment', 'content', 'abuse', 'bug', 'other']);
export const TicketStatus = z.enum([
    'open',
    'in_progress',
    'waiting_on_member',
    'resolved',
    'closed',
]);
export const CreateTicketInput = z.object({
    subject: z.string().trim().min(3).max(120),
    category: TicketCategory,
    description: z.string().trim().min(10).max(5_000),
    attachments: z.array(HttpUrl).max(5).default([]),
});
export const TicketReplyInput = z.object({ body: z.string().trim().min(1).max(5_000) });
export const TicketMessage = z.object({
    id: z.string(),
    /** 'member' or 'agent' — the threaded conversation (AC-HELP-01.2). */
    from: z.enum(['member', 'agent']),
    body: z.string(),
    createdAt: z.coerce.date(),
});
export const TicketView = z.object({
    id: z.string(),
    /** Human reference, e.g. ONV-000123. */
    reference: z.string(),
    subject: z.string(),
    category: TicketCategory,
    status: TicketStatus,
    messages: z.array(TicketMessage),
    createdAt: z.coerce.date(),
    updatedAt: z.coerce.date(),
});
export const TicketSummary = TicketView.omit({ messages: true });
/** Versioned policy documents (FR-HELP-03, FR-ADM-63). */
export const PolicyKind = z.enum(['terms', 'privacy', 'community_guidelines']);
export const PolicyView = z.object({
    kind: PolicyKind,
    version: z.number().int().positive(),
    title: z.string(),
    bodyMarkdown: z.string(),
    effectiveAt: z.coerce.date(),
});
export const FaqEntry = z.object({
    id: z.string(),
    group: z.string(),
    question: z.string(),
    answerMarkdown: z.string(),
    order: z.number().int(),
});
//# sourceMappingURL=help.js.map